import { UserOutlined } from "@ant-design/icons";

export const GuestDetails = (props) => {
  const { selectedBooking } = props;
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <UserOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
        <h3 style={{ margin: 0, color: "#333" }}>Guest Details</h3>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "10px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Name:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.guestName || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Email:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.guestEmail || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Phone:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.guestPhoneNumber || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Nationality:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.guestNationality || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Address:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.guestAddress || "N/A"}
          </span>
        </p>
      </div>
    </div>
  );
};
